import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SectionCard = ({ children, elevation = 1, sx = {}, ...props }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={elevation}
      sx={{
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[elevation],
        padding: { xs: 2, md: 4 },
        background: theme.palette.background.paper,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

SectionCard.propTypes = {
  children: PropTypes.node,
  elevation: PropTypes.number,
  sx: PropTypes.object,
};

export default SectionCard; 